import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  dialogContainer: {
    width: 510,
    maxWidth: '100%',
    borderRadius: 4,
    overflow: 'hidden',
  },

  content: {
    padding: '36px 32px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
  },

  titleSpace: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 32,
  },

  titleText: {
    textAlign: 'center',
    lineHeight: 1.2,
  },

  inputSpace: {
    width: '100%',
    '& .MuiFormHelperText-root': {
      minHeight: '40px',
    },
  },

  buttonSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '28px',
  },

  cancelButton: {
    fontWeight: 500,
    fontSize: 16,
    color: '#353535',
    textTransform: 'uppercase',
    padding: '8px 22px',
    borderRadius: 4,
    background: '#fff',
    boxShadow: 'none',
    '&:hover': {
      background: 'rgba(0,0,0,0.04)',
      boxShadow: 'none',
    },
  },
});

export default styles;
export const useStyles = makeStyles(styles);
